import React from 'react';
import Alert from '@storeblocks/alert';
import { getText } from '@storebrand-digital/fms-translations';
import Markdown from '../Markdown';
function ErrorComponent(_a) {
    var isCompose = _a.isCompose, error = _a.error;
    if (isCompose && error.status === 401) {
        return (React.createElement(Alert, { variant: "error", title: getText('error.unauthorized.title'), fluid: true }, getText('error.unauthorized.description')));
    }
    if (isCompose) {
        return (React.createElement(Alert, { variant: "error", title: getText('error.title'), fluid: true }, getText('error.compose.description')));
    }
    return (React.createElement(Alert, { variant: "error", title: getText('error.title'), fluid: true },
        React.createElement(Markdown, { text: getText('error.description') })));
}
export default ErrorComponent;
